<template>
	<div>
		<Payments/>
	</div>
</template>

<script>
import Payments from '@/components/templates/Payments.vue'
export default {
	components: {
		Payments
	}
}
</script>